/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSectorCommand } from '../../models/create-sector-command';
import { CreateSectorCommandResult } from '../../models/create-sector-command-result';

export interface ApiSectorCreateSectorPost$Plain$Params {
      body?: CreateSectorCommand
}

export function apiSectorCreateSectorPost$Plain(http: HttpClient, rootUrl: string, params?: ApiSectorCreateSectorPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSectorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSectorCreateSectorPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateSectorCommandResult>;
    })
  );
}

apiSectorCreateSectorPost$Plain.PATH = '/api/Sector/CreateSector';
